/* global getThemeFile */

jQuery(function ($) {

    var MOBILE_WIDTH = 980;                      // The mobile breakpoint.
    var $body = $('body'),  // Remove the no-js class from the body.
        $nav = $('.mega-inner'),        // The full navbar menu.
        $navItems = $nav.find('> li.has-mega-menu'),  
        $navBar = $('.navbar-header'),         // Each navbar menu item.
        $navMenus = $navItems.find('.mega-menu__wrapper'); // Each navbar sub-menu.
    var clickThrough = true;                     // Whether the click should trigger.

    $nav.on({
        'pointerdown': function () {
            clickThrough = false;
        }
    }).attr('touch-action', 'pan-x pan-y');

    $navItems.on('pointerup', touchOpen).on('click', function () {
        return clickThrough;
    });

    /**
     * If the window has hit the mobile breakpoint.
     * @returns {boolean} true if mobile
     */
    function isMobile() {
        return window.innerWidth <= MOBILE_WIDTH;
    }

    /**
     * Touch to open a menu item.
     * @param {InputEvent} e The touch event
     * @return {void}
     */
    function touchOpen(e) {
        var $item = $(this).closest('.has-mega-menu');

        clickThrough = e.originalEvent.pointerType === 'mouse' && !isMobile();
        if (!$navMenus.is(':visible')) {
            // Open the menu.
            open($item.addClass('highlighted'));
        } else if (!$item.find('.mega-menu__wrapper').is(':visible')) {
            // Switch to a different menu.
            $navMenus.find(':visible').closest('.has-mega-menu').removeClass('highlighted');
            open($item.addClass('highlighted'));
        } else {
            clickThrough = true;
        }
    }

    /**
     * Touch to close a menu item.
     * @param {InputEvent} e The touch event
     * @return {void}
     */
    function touchClose(e) {
        if (($(e.target).parents('.mega-inner').length === 0) && $navMenus.is(':visible')) {
            // Close the menu.
            close($navMenus.filter(':visible').closest('.has-mega-menu').removeClass('highlighted'));
            $body.off('touchend click', touchClose);
        }
    }

    /**
     * Open a sub-menu.
     * @param {jQuery} $item The navItem to open
     * @return {void}
     */
    function open($item) {
        var $subMenu = $item.find('.mega-menu__wrapper');
        var $anchor = $item.find('a');

        if ($nav.height() > 80 && !isMobile()) {
            $subMenu.css('top', $nav.height() - parseInt($item.css('padding-top'), 10));
        } else {
            $subMenu.css('top', '');
        }

        if ($navMenus.is(':visible')) {
            var $otherMenu = $('.mega-menu__wrapper:visible');

            if (!$otherMenu.is($subMenu)) {
                var otherHeight = $otherMenu.outerHeight();
                var subHeight = $subMenu.outerHeight();
                // Close the other menu.
                $otherMenu.hide();

                // Open the new one, transitioning to the correct height.
                $subMenu.css({
                    height: otherHeight,
                    display: 'block'
                }).animate({height: subHeight}, function () {
                    $subMenu.height('auto');
                });
            }
        } else {
            $subMenu.slideDown();
            $body.on('touchend click', touchClose);
        }
    }

    /**
     * Close a sub-menu.
     * @param {jQuery} $item The navItem to close
     * @return {void}
     */
    function close($item) {
        $item.find('.mega-menu__wrapper').slideUp();
    }

    /*
     *  Fixed Issues that were found on mobile on BC
     */
    $(window).resize(function () {
        $navItems.each(function () {
            close($(this));
        });
    });

    /*
     *   When a touch happens on a dual touch/mouse device (like a touch laptop)
     *   a cursor is left in that spot which activates hover. Adding a mousemove
     *   listener prevents the menu from being expanded after using the parent menu
     *   item to navigate to a page.
     */
    $body.one('mousemove', function () {
        $navItems.hoverIntent({
            over: function () {
                if (!isMobile()) {
                    open($(this));
                }
            },
            out: function () {
                if (!isMobile()) {
                    close($(this));
                }
            },
            sensitivity: 5,
            timeout: 300
        });
    });
});
